/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'size': {
    width: 14,
    height: 14,
    viewBox: '0 0 14 14',
    data: '<circle pid="0" cx="7" cy="6.504" r="6" _stroke="#fff"/><circle pid="1" cx="4" cy="6.504" r="3" _stroke="#fff"/>'
  }
})
